import React from 'react';
import { Box, Typography, Button, Container, Stack } from '@mui/material';
import { ErrorOutline, Home, Refresh } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PaymentFailurePage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Redirigir al home o a la página principal
    navigate('/');
  };

  const handleTryAgain = () => {
    // Volver a la página anterior o al portal de pagos
    navigate(-1);
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <ErrorOutline
          sx={{
            fontSize: 80,
            color: 'error.main',
            mb: 3,
          }}
        />

        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2.125rem' },
          }}
        >
          Pago no procesado
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            maxWidth: 400,
            lineHeight: 1.6,
            fontSize: '1.1rem',
          }}
        >
          No pudimos procesar tu pago. Por favor, verifica los datos de tu
          tarjeta e intenta nuevamente.
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Button
            variant="contained"
            onClick={handleTryAgain}
            startIcon={<Refresh />}
            sx={{
              py: 1.5,
              px: 3,
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Intentar nuevamente
          </Button>

          <Button
            variant="outlined"
            onClick={handleGoHome}
            startIcon={<Home />}
            sx={{
              py: 1.5,
              px: 3,
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Volver al inicio
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default PaymentFailurePage;
